module.exports = __webpack_public_path__ + "static/media/Search Sanctions Person ID.90b9cf10.xlsx";